import { render, staticRenderFns } from "./ConfirmacionEliminarRefereneciaDialogComponent.vue?vue&type=template&id=d562cdd2"
import script from "./ConfirmacionEliminarRefereneciaDialogComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmacionEliminarRefereneciaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports